import { aboutData } from '@/mocks/home-data';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 items-center">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-3">
              <span className="w-1 h-6 bg-secondary-500 rounded-full"></span>
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
                {aboutData.title}
              </h2>
            </div>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              {aboutData.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-xs lg:max-w-sm">
            <div className="aspect-square rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20editorial%20office%20scene%20with%20warm%20crimson%20and%20amber%20accents%2C%20newsroom%20vibe%2C%20multiple%20screens%20displaying%20breaking%20news%2C%20professional%20yet%20creative%20atmosphere%2C%20soft%20natural%20lighting%2C%20minimalist%20workspace%2C%20clean%20composition&width=600&height=600&seq=about-brand-bagua&orientation=squarish"
                alt="爆料吃瓜编辑团队"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}